import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import persistState from 'redux-localstorage';

const initialState = {};

const middleware = [thunk];


const store = createStore(
  rootReducer,
  initialState,
  compose(
    persistState('auth', []),
    applyMiddleware(...middleware),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f
  )
);

export default store;
